(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["protocol-v2-issue-001"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const sliders = document.querySelectorAll('[data-px-campaign-slider]');

    sliders.forEach((slider) => {
      if (slider.dataset.pxReady === 'true') return;
      slider.dataset.pxReady = 'true';

      const slides = Array.from(slider.querySelectorAll('[data-px-slide]'));
      const dots = Array.from(slider.querySelectorAll('[data-px-dot]'));
      const previous = slider.querySelector('[data-px-prev]');
      const next = slider.querySelector('[data-px-next]');
      const pause = slider.querySelector('[data-px-pause]');
      const status = slider.querySelector('[data-px-status]');
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      if (slides.length < 2) return;

      let index = 0;
      let timer = null;
      let manuallyPaused = reducedMotion;

      const render = (nextIndex, announce = true) => {
        index = (nextIndex + slides.length) % slides.length;

        slides.forEach((slide, slideIndex) => {
          const active = slideIndex === index;
          slide.classList.toggle('is-active', active);
          slide.setAttribute('aria-hidden', active ? 'false' : 'true');
          slide.tabIndex = active ? 0 : -1;
        });

        dots.forEach((dot, dotIndex) => {
          const active = dotIndex === index;
          dot.classList.toggle('is-active', active);
          if (active) {
            dot.setAttribute('aria-current', 'true');
          } else {
            dot.removeAttribute('aria-current');
          }
        });

        if (status && announce) {
          status.textContent = dots[index]?.dataset.label || '';
        }
      };

      const stop = () => {
        if (timer) {
          window.clearInterval(timer);
          timer = null;
        }
      };

      const start = () => {
        stop();
        if (manuallyPaused || reducedMotion || document.hidden) return;
        timer = window.setInterval(() => render(index + 1, false), 6500);
      };

      const restart = () => {
        stop();
        start();
      };

      previous?.addEventListener('click', () => {
        render(index - 1);
        restart();
      });

      next?.addEventListener('click', () => {
        render(index + 1);
        restart();
      });

      dots.forEach((dot, dotIndex) => {
        dot.addEventListener('click', () => {
          render(dotIndex);
          restart();
        });
      });

      pause?.addEventListener('click', () => {
        manuallyPaused = !manuallyPaused;
        pause.textContent = manuallyPaused ? '▶' : 'Ⅱ';
        pause.setAttribute(
          'aria-label',
          manuallyPaused ? pause.dataset.playLabel : pause.dataset.pauseLabel
        );

        if (manuallyPaused) {
          stop();
        } else {
          start();
        }
      });

      slider.addEventListener('pointerenter', stop);
      slider.addEventListener('pointerleave', start);
      slider.addEventListener('focusin', stop);
      slider.addEventListener('focusout', (event) => {
        if (!slider.contains(event.relatedTarget)) start();
      });

      document.addEventListener('visibilitychange', () => {
        if (document.hidden) stop();
        else start();
      });

      render(0, false);
      start();
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
